<template>
  <div class="inventory">
    <h1 class="mb-4">Inventory Management</h1>
    <div class="bg-white table-shadow p-4 mb-4">
      <CustomerSelect :create-customer-allowed="false" @selected="handleSelect" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { STAFF_INVENTORY_PRODUCTS } from '@/types/router'
import CustomerSelect from '@/views/Components/Customer/CustomerSelect.vue'

export default defineComponent({
  name: 'InventorySelectPage',
  components: { CustomerSelect },
  setup() {
    const router = useRouter()

    const handleSelect = (id: string) => {
      router.push({
        name: STAFF_INVENTORY_PRODUCTS,
        params: { customerId: id },
      })
    }

    return { handleSelect }
  },
})
</script>
